<template>
  <div>
    <v-card class="transparent elevation-0">
      <v-container container--fluid grid-list-md>
        <v-row>
          <v-col cols="12" :class="{'text-center': $vuetify.breakpoint.smAndDown}">
            <h1>API Setting</h1>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field label="Search..." v-model="search" prepend-icon="search"></v-text-field>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" md="2">
            <v-row align="center">
              <v-col cols="12" md="6" class="text-center">
                <v-tooltip top color="secondary">
                  <template v-slot:activator="{ on }">
                    <v-btn class="mx-2" fab dark color="blue lighten-1" @click="newSetting" v-on="on">
                      <v-icon dark>add</v-icon>
                    </v-btn>
                  </template>
                  <span>Create a new</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
      <v-divider></v-divider>
      <v-data-table
        :headers="headers"
        :items="renderedSetting"
        :search="search"
      >
        <template v-slot:item="props">
          <tr class="cursor" v-bind:class="{odd: props.index % 2, even: !props.index % 2}">
            <td v-if="header.text !== 'Actions'" style="text-align: center" v-for="(header, index) in headers" :key="index">
              {{props.item[header.value]}}
            </td>
            <td v-show="admin " style="text-align: center">
              <v-tooltip top color="secondary">
                <template v-slot:activator="{ on }">
                  <v-icon  color="blue" @click="rowSelected(props.item) " v-on="on">
                    edit
                  </v-icon>
                </template>
                <span>Edit</span>
              </v-tooltip>
              <v-tooltip top color="secondary">
                <template v-slot:activator="{ on }">
                  <v-icon color="red" @click="toggleDeleteDialog(props.item)" v-on="on" class="pl-1">
                    delete
                  </v-icon>
                </template>
                <span>Delete</span>
              </v-tooltip>
            </td>

          </tr>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog
      v-model="deleteDialog"
      max-width="500px"
      persistent
    >
      <v-card>
        <v-card-title>
          <h3>ATTENTION</h3>
        </v-card-title>
        <v-card-text>
          You are about to delete this setting. This action cannot be undone. <br>
          Are you sure you want to proceed ?
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text color="blue-grey lighten-2" @click="toBeDeleted=null; deleteDialog=false">No</v-btn>
          <v-btn text color="blue darken-1" @click="deleteSetting">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog v-model="editDialog"  width="800px">
      <v-card>
        <v-card-title class="d-flex" style="position: relative" :class="$vuetify.breakpoint.smAndDown ? 'justify-start' : 'justify-center'">
          <h2>{{editedIndex > -1 ? 'Edit setting' : 'New setting'}}</h2>
          <v-btn icon style="position: absolute; right: 15px; top: 10px;" @click="editDialog=false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>

        <v-card-text :class="{'pa-0': $vuetify.breakpoint.smAndDown}">
          <v-container container--fluid grid-list-xl pb-0>
            <v-form
              ref="form"
              v-model="valid">
              <v-row justify="space-around">
                <v-row>
                  <v-col cols="6" md="5">
                    <v-combobox
                      :rules="requiredRule"
                      item-color="blue"
                      prepend-icon="person"
                      label="Name"
                      :items="apiName"
                      v-model="apiSetting.name"
                    ></v-combobox>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="12" md="5">
                    <v-select
                      :rules="requiredRule"
                      item-color="blue"
                      prepend-icon="book"
                      label="Type"
                      :items="types"
                      v-model="apiSetting.type"
                    ></v-select>
                  </v-col>

                </v-row>
                <v-row justify="space-around">
                  <v-col cols="6" md="5">
                    <v-select
                      prepend-icon="location_city"
                      item-color="blue"
                      label="Region"
                      :items="regions"
                      item-text="name"
                      item-value="id"
                      v-model="apiSetting.region"
                    ></v-select>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col v-if="apiSetting.type === 'boolean'" cols="6" md="5">
                    <v-select
                      :items="fault"
                      item-color="blue"
                      prepend-icon="speaker_notes"
                      label="Value"
                      v-model="apiSetting.value"
                    ></v-select>
                  </v-col>
                  <v-col  v-else cols="6" md="5">
                    <v-text-field
                      item-color="blue"
                      prepend-icon="speaker_notes"
                      label="Value"
                      v-model="apiSetting.value"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-row>
              <v-row justify="center" align="center" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
                <v-col cols="12" md="3" class="text-center">
                  <v-btn
                    text
                    @click="editDialog=false"
                    color="blue-grey lighten-2"
                  >Cancel
                  </v-btn>
                </v-col>
                <v-col cols="12" md="3" class="text-center">
                  <v-btn
                    text
                    @click="saveChanges"
                    color="blue darken-1"
                  >Save
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import axios from "axios";

export default {
name: "Setting",
  props: {
    default: function () {
      return {
        region: Object,
        regions: Array
      }
    }
  },
  data() {
    return {
      valid: false,
      requiredRule: [
        v => !!v || 'This field is required.'
      ],

      reload: false,
      search: null,
      toBeDeleted: null,
      deleteDialog: false,
      allSwitch: false,
      editedIndex: -1,
      editedItem: {
        name:null,
        type:null,
        region: 0,
        value:null,
      },
      apiSetting: {
        name:null,
        type:null,
        region: 0,
        value:null,
      },
      editDialog: false,
      displayedItem: null,
      region: null,
      headers:[
        {text: 'Name', value: 'name', align: 'center', sortable: true},
        {text: 'Type', value: 'type', align: 'center', sortable: true},
        {text: 'Region', value: 'region_name', align: 'center', sortable: true},
        {text: 'Value', value: 'value', align: 'center', sortable: true},
        {text: 'Actions', value: 'actions', align: 'center', sortable: false,}
      ],
      types:[
        'emails',
        'string',
        'boolean',
        'integer',
      ],
      fault:[
        true,
        false,
      ],
      apiName:[],
    }
  },
  methods: {
    newSetting() {
      this.editedIndex = -1;
      this.apiSetting = Object.assign({}, this.editedItem);
      this.editDialog = true;
    },
    rowSelected(item) {
      this.apiSetting.name = item['name'];
      this.apiSetting.type = item['type'];
      this.apiSetting.region = item['region_id'] * 1;
      if(item['type'] === 'boolean'){
        this.apiSetting.value = Boolean(item['value']);
      } else this.apiSetting.value = item['value'];
      this.editedIndex = this.apiSettings.indexOf(item);
      this.editDialog = true;
    },
    updateDataTable() {
      this.reload = !this.reload;
    },
    toggleDeleteDialog(item) {
      this.toBeDeleted = item;
      this.deleteDialog = true;
    },
    deleteSetting() {
      axios.post(process.env.API_URL + '/apisetting/delete' , this.toBeDeleted)
        .then((response) => {
          this.updateDataTable();
          this.deleteDialog = false;
        })
        .catch((response) => {
          this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
        })
    },
    validationInput(body){
      if (body.type === 'emails') {
        let tem =[];
        let emails = body.value.split(';');
        for(var index in emails){
          if(!emails[index].match(/^(([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+([,.](([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+)*$/)){
            this.$store.commit('displaySnackbar', 'Invalid email');
            return false;
          }
          tem.push(emails[index]);
        }
        body.value = tem;
        return true;
      } else if (body.type === 'integer') {
        if(!body.value.match(/^-?\d+$/)){
          this.$store.commit('displaySnackbar', 'Invalid integer');
          return false;
        } else {
          body.value = body.value * 1;
          return true;
        }
      }  else {
        return true;
      }
    },
    saveChanges() {
      let body = this.apiSetting;
      if(!this.validationInput(body)){
        return false;
      };

      if (this.editedIndex > -1) {
        axios.put(process.env.API_URL + '/apisetting' , body)
          .then((response) => {
            this.updateDataTable();
            this.$store.commit('displaySnackbar', 'Changes saved.');
          })
          .catch((response) => {
            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
          })
      } else {
        axios.post(process.env.API_URL + '/apisetting', body)
          .then((response) => {
            this.updateDataTable();
            this.$store.commit('displaySnackbar', 'Apisetting created.');
          })
          .catch((response) => {
            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
          })
      }
      this.editDialog = false;
    }
  },
  computed: {
    admin() {
      return this.$store.getters['auth/isAdmin'];
    },
    renderedSetting() {
      if (this.apiSettings === null) return [];
      for(var key in this.apiSettings){
         this.apiName.push(this.apiSettings[key]['name']);
      }
      this.apiSettings = this.apiSettings.map(
        item => {
          const container = Object.assign({}, item);
          for(var key in this.regions){
            if(this.regions[key]['id'] === item["region_id"]){
              container['region_name'] = this.regions[key]['name'];
            }
          }
          return container;
        });
      return this.apiSettings
    },
    regions: function () {
      let regions = this.$store.getters['auth/regions'];
      if (this.$store.getters['auth/isAdmin']) {
        regions.push({"id": 0, "name": "Global"});
      }
      return regions;
    }
  },
  mounted() {
    this.region = this.regions[0];
  },
  asyncComputed: {
    async apiSettings() {
      if (this.reload || !this.reload) {
        return await axios.get(process.env.API_URL + '/apisetting')
          .then((response) => {
            return response.data;
          })
          .catch((response) => {
            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
            return [];
          });
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Admin/Settings.vue